import { render, staticRenderFns } from "./NoticeSingle.vue?vue&type=template&id=9b4c5f7c&"
import script from "./NoticeSingle.vue?vue&type=script&lang=js&"
export * from "./NoticeSingle.vue?vue&type=script&lang=js&"
import style0 from "./NoticeSingle.vue?vue&type=style&index=0&id=9b4c5f7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports